export const LOW_CREDITS_THRESHOLD = 500;

export const CREDIT_BALANCE_REFETCH_INTERVAL_MS = 2 * 60 * 1000;

export const DISMISSED_ALERT_SESSION_KEY = 'low-credits-alert-dismissed';
